import REQUEST from './Request';

export const submitOrientationForm = async (formData) => {
  return await REQUEST({
    method: "POST",
    url: "Feedback/orientation",
    data: formData,
  });
};

export const getOrientationData = async (salesId) => {
  return await REQUEST({
    method: "GET",
    url: `orientation/${salesId}`,
  });
};

export const generateQRCode = async (salesId) => {
  return await REQUEST({
    method: "POST",
    url: "orientation/qr-code",
    data: { salesId },
  });
};

export const trackOrientationAction = async (actionData) => {
  return await REQUEST({
    method: "POST",
    url: "orientation/track",
    data: actionData,
  });
}; 